<section :class="$style.overlayFoundryInfo">
    <div :class="$style.overlayFoundryInfoSec" ref="overlayInfoSec">
        <Close @click="closeOverlayInfo"/>
        <MdTypography :class="$style.overlayFoundryInfoSecTitle" variant="heading5--medium" responsive="false">
            {{displayTitle}}
        </MdTypography>
        <MdTypography :class="$style.overlayFoundryInfoSecOptional" v-if="overlaySection !== 'contactInformation'" tag="div" color="spirits--700" variant="body2--regular" responsive="false">
            {{$t('pages.profile.new_foundry.optional')}}
        </MdTypography>
        <p v-if="overlaySection !== 'foundryImagery'">
            <MdTypography variant="body1--regular" color="spirits--700" tag="p" responsive="false">
                {{$t('pages.profile.new_foundry.foundryInformationdesc1')}}
            </MdTypography>
            <MdTypography variant="body1--regular" color="spirits--700" tag="p" responsive="false">
                {{$t('pages.profile.new_foundry.foundryInformationdesc2')}}
            </MdTypography>
            <MdTypography variant="body1--regular" color="spirits--700" tag="p" responsive="false">
                {{$t('pages.profile.new_foundry.foundryInformationdesc3')}}
            </MdTypography>
        </p>
        <div v-else :class="$style.overlayFoundryInfoImagery">
            <div>
                <MdTypography :class="$style.overlayFoundryInfoImgTitle" color="spirits--700" variant="body1--bold" tag="p" responsive="false">
                    {{displayDesc.logo}}
                </MdTypography>
                <MdTypography :class="$style.overlayFoundryInfoImgRes" color="spirits--700" variant="body1--regular" tag="p" responsive="false">
                    {{$t('pages.profile.new_foundry.resolution')}}: 
                    <MdTypography variant="body1--medium" color="spirits--700" tag="span" responsive="false">
                        {{displayDesc.resolutionLogo}}
                    </MdTypography>
                </MdTypography>
                <MdTypography :class="$style.overlayFoundryInfoImgRes" color="spirits--700" variant="body1--regular" tag="p" responsive="false">
                    {{$t('pages.profile.new_foundry.size')}}: 
                     <MdTypography variant="body1--medium" color="spirits--700" tag="span" responsive="false">
                        {{displayDesc.sizeLogo}}
                    </MdTypography>
                </MdTypography>
                <MdTypography :class="$style.overlayFoundryInfoImgRes" color="spirits--700" variant="body1--regular" tag="p" responsive="false">
                    {{$t('pages.profile.new_foundry.format')}}:  
                    <MdTypography variant="body1--medium" color="spirits--700" tag="span" responsive="false">
                        {{displayDesc.format}}
                    </MdTypography>
                </MdTypography>
            </div>
            <div>
                <MdTypography :class="$style.overlayFoundryInfoImgTitle" color="spirits--700" variant="body1--bold" tag="p" responsive="false">
                    {{displayDesc.banner}}
                </MdTypography>
                <MdTypography :class="$style.overlayFoundryInfoImgRes" color="spirits--700" variant="body1--regular" tag="p" responsive="false">
                    {{$t('pages.profile.new_foundry.resolution')}}:  
                    <MdTypography variant="body1--medium" color="spirits--700" tag="span" responsive="false">
                        {{displayDesc.resolutionBanner}}
                    </MdTypography>
                </MdTypography>
                <MdTypography :class="$style.overlayFoundryInfoImgRes" color="spirits--700" variant="body1--regular" tag="p" responsive="false">
                    {{$t('pages.profile.new_foundry.size')}}:   
                    <MdTypography variant="body1--medium" color="spirits--700" tag="span" responsive="false">
                        {{displayDesc.sizeBanner}}
                    </MdTypography>
                </MdTypography>
                <MdTypography :class="$style.overlayFoundryInfoImgRes" color="spirits--700" variant="body1--regular" tag="p" responsive="false">
                    {{$t('pages.profile.new_foundry.format')}}:   
                    <MdTypography variant="body1--medium" color="spirits--700" tag="span" responsive="false">
                        {{displayDesc.format}}
                    </MdTypography>
                </MdTypography>
            </div>
            <MdTypography :class="$style.overlayFoundryInfoImgDesc" color="spirits--700" variant="body1--regular" tag="p" responsive="false">
                {{displayDesc.desc}}
            </MdTypography>
        </div>
    </div>
</section>